module.exports = {
    PAGE_NAME: "Trade Mirror",
    // API_URL: "https://trade.ptx.ro",
    API_URL: ""
}